<template>
  <div style="position: relative">
    <Spin fix v-if="tongbuLoading || exportAllLoading"></Spin>
    <!-- 新增按钮 -->

    <Input
      v-model="searchId"
      placeholder="输入用户ID"
      style="width: 200px; margin-right: 10px"
    />

    <Button type="primary" @click="queryGoods">查询</Button>
    <Button type="primary" @click="clickhedan">合单</Button>
    <!-- <Button type="primary" @click="clickdaochu2">导出给石总</Button> -->
    <Button type="primary" @click="clickdaochuall">导出全部已采购</Button>
    <Button type="primary" @click="clickupexcel">批量填单</Button>
    <!-- <Button type="primary" @click="clicktongbu">同步本地库存</Button> -->

    <Table :columns="columns10" :data="data9" defaultExpandAllRows> </Table>
    <div style="margin: 10px; overflow: hidden">
      <div style="float: right">
        <Page
          :total="total"
          :current="current"
          :page-size="50"
          @on-change="changePage"
        ></Page>
      </div>
    </div>

    <Modal
      v-model="couriernumModal"
      title="请填写快递单号"
      @on-ok="couriernumModalOk"
      @on-cancel="couriernumModal = false"
    >
      <Input
        v-model="couriernum"
        placeholder="请填写快递单号"
        style="width: 200px"
      />
    </Modal>
    <Modal
      v-model="returnModal"
      title="请选择退回原因"
      @on-ok="returnModalOk"
      @on-cancel="returnModal = false"
    >
      <Select v-model="selectedReturn" placeholder="请选择退回原因">
        <Option
          v-for="item in returnreason"
          :key="item.value"
          :value="item.value"
        >
          {{ item.label }}
        </Option>
      </Select>

      <Input
        v-if="isallreturn == false"
        v-model="returnnum"
        placeholder="请输入商品数量"
        :min="1"
        style="width: 200px"
        @on-input="validatePositiveInteger"
      />
    </Modal>

    <Modal
      v-model="remarkModal"
      title="修改备注"
      @on-ok="remarkModalOk"
      @on-cancel="remarkModal = false"
    >
      <Input
        v-model="newRemark"
        placeholder="请输入备注"
        style="width: 300px"
      />
    </Modal>
  </div>
</template>

<script>
const RETURN_REASONS = [
  { value: "碎片不足，无法发货", label: "碎片不足，无法发货" },
  {
    value: "地址不详，请联系客服提供地址",
    label: "地址不详，请联系客服提供地址",
  },
  { value: "请备注下礼品名称", label: "请备注下礼品名称" },
];
import SingleUpload from "@/components/Upload/singleUpload";
import {
  cmsSelShopOrder,
  cmsHebinOrder,
  cmsReturnOrder,
  cmsDeliverGoods,
  cmsUpdateRemark,
  cmsTongbubendi,
  piliangDeliverGoods,
  cmsAllYicaigou,
} from "../../api/fahuo";
import ExcelJS from "exceljs";
import expandRow from "./fahuolist_expand.vue";

export default {
  components: { expandRow, SingleUpload },
  data() {
    return {
      couriernumModal: false,
      couriernum: "",
      remarkModal: false,
      newRemark: "",
      currentRemarkRow: null,
      goodstypeOptions: this.$goodsTypeOptions,
      selectedRows: [], // 用于保存选中的行
      returnreason: RETURN_REASONS,
      returnModal: false,
      returnreasonIDs: [],
      selectedReturn: "",
      isallreturn: false,
      returnnum: "",
      loading: false,
      data9: [], // 用于存储查询结果
      columns10: [
        {
          type: "expand",
          width: 50,
          defaultExpanded: true,
          render: (h, params) => {
            return h(expandRow, {
              props: {
                row: params.row,
              },
              on: {
                triggerQueryGoods: this.queryGoods,
                triggerReturnOrder: (rowData) => {
                  console.log("rowData", rowData[0]);
                  if (rowData[0].goodsnum > 1) {
                    this.isallreturn = false;
                  } else {
                    this.isallreturn = true;
                  }
                  this.returnOrder(rowData); // 调用 returnOrder 方法并传递参数
                }, // 监听 expandRow 的事件，并调用 queryGoods
              },
            });
          },
        },
        {
          title: "合单",
          key: "action",
          width: 100,
          align: "center",
          render: (h, params) => {
            return h("div", [
              h("Checkbox", {
                props: {
                  type: "primary",
                  size: "small",
                  value: this.selectedRows.includes(params.row), // 判断是否选中
                },
                style: {
                  marginRight: "5px",
                },
                on: {
                  "on-change": (isChecked) => {
                    console.log("change", isChecked);
                    // 如果选中，将该行加入数组，否则从数组中移除
                    if (isChecked) {
                      this.selectedRows.push(params.row);
                    } else {
                      this.selectedRows = this.selectedRows.filter(
                        (row) => row !== params.row,
                      );
                    }
                  },
                },
              }),
            ]);
          },
        },

        {
          title: "订单号",
          key: "ordernum",
        },
        {
          title: "总成本",
          key: "cost",
        },
        {
          title: "商品数量",
          key: "goodsnum",
        },

        {
          title: "用户id",
          key: "user_id",
        },

        {
          title: "用户手机号",
          key: "user_phone",
        },
        {
          title: "用户信息",
          key: "user_nickname",
          render: (h, params) => {
            var nickname =
              params.row.user_nickname +
              " " +
              params.row.user_phone +
              " " +
              params.row.user_address;
            return h("span", nickname);
          },
        },
        {
          title: "备注",
          key: "remarks",
          render: (h, params) => {
            var re = params.row.myremarks
              ? params.row.myremarks
              : params.row.remarks;
            return h("span", re);
          },
        },
        {
          title: "申请时间",
          key: "createtime",
        },
        {
          title: "操作",
          key: "action",
          width: 250,
          align: "center",
          render: (h, params) => {
            // 判断逻辑：如果 params.row.rows 中的 procurestatus 都等于 1
            const allProcureStatusIsOne = params.row.rows.every(
              (row) => row.procurestatus === 1,
            );

            return h("div", [
              // 根据判断结果渲染按钮
              allProcureStatusIsOne
                ? h(
                    "Button",
                    {
                      props: {
                        type: "primary",
                        size: "small",
                      },
                      style: {
                        marginRight: "5px",
                      },
                      on: {
                        click: () => {
                          // 按钮的点击事件逻辑
                          this.fahuoOrder(params.row.rows);
                        },
                      },
                    },
                    "填写单号",
                  )
                : null, // 如果条件不满足，不显示按钮
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.openRemarkModal(params.row, params.row.rows);
                    },
                  },
                },
                "修改备注",
              ),
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  on: {
                    click: () => {
                      this.isallreturn = true;
                      this.returnOrder(params.row.rows);
                    },
                  },
                },
                "退回整单",
              ),
            ]);
          },
        },
      ],
      searchId: "",
      searchName: "",
      searchType: "",
      current: 1,
      total: 0,
      batchExcelRows: [],
      tongbuLoading: false,
      exportAllLoading: false,
    };
  },

  mounted() {
    this.queryGoods();
  },
  methods: {
    normalizeExcelText(value) {
      if (value === null || value === undefined) return "";
      const text = String(value).trim();
      if (text.length >= 2 && text.startsWith('"') && text.endsWith('"')) {
        return text.slice(1, -1);
      }
      return text;
    },
    getExcelCellDisplayValue(value) {
      if (value === null || value === undefined) return "";
      if (typeof value === "object") {
        if (value.text !== undefined)
          return this.normalizeExcelText(value.text);
        if (value.result !== undefined)
          return this.normalizeExcelText(value.result);
        if (value.richText && Array.isArray(value.richText)) {
          return this.normalizeExcelText(
            value.richText
              .map((item) => (item && item.text ? item.text : ""))
              .join(""),
          );
        }
      }
      return this.normalizeExcelText(value);
    },
    clickupexcel() {
      const input = document.createElement("input");
      input.type = "file";
      input.accept = ".xlsx,.xls";
      input.style.display = "none";

      input.onchange = async (event) => {
        const file =
          event && event.target && event.target.files
            ? event.target.files[0]
            : null;
        if (!file) {
          return;
        }

        const fileName = (file.name || "").toLowerCase();
        if (!/\.(xlsx|xls)$/.test(fileName)) {
          this.$Message.error("请上传 .xlsx 或 .xls 文件");
          return;
        }

        try {
          const workbook = new ExcelJS.Workbook();
          const buffer = await file.arrayBuffer();
          await workbook.xlsx.load(buffer);

          const worksheet = workbook.worksheets[0];
          if (!worksheet) {
            this.$Message.error("未读取到工作表");
            return;
          }

          const parsedRows = [];
          worksheet.eachRow((row, rowNumber) => {
            const values = (row.values || [])
              .slice(1)
              .map((cellValue) => this.getExcelCellDisplayValue(cellValue));

            const hasValue = values.some(
              (item) => this.normalizeExcelText(item) !== "",
            );
            if (!hasValue) return;

            const rowObj = {
              rowNumber,
              ordernum: values[0] || "",
              couriernum: values[1] || "",
            };
            values.forEach((item, index) => {
              rowObj[`col${index + 1}`] = item;
            });
            parsedRows.push(rowObj);
          });

          if (parsedRows.length === 0) {
            this.$Message.error("Excel 内容为空");
            return;
          }

          this.batchExcelRows = parsedRows;
          const arr = [];
          for (let i = 0; i < this.batchExcelRows.length; i++) {
            const dic = {};
            const element = this.batchExcelRows[i];
            dic["ordernum"] = element["col2"];
            dic["kdnum"] = element["col1"];
            arr.push(dic);
          }

          piliangDeliverGoods({
            items: arr,
          }).then(() => {
            this.$Message.success("批量填单成功");
            this.queryGoods();
          });
        } catch (error) {
          console.error("批量填单 Excel 读取失败:", error);
          this.$Message.error("Excel 读取失败，请检查文件格式");
        }
      };

      document.body.appendChild(input);
      input.click();
      document.body.removeChild(input);
    },
    openRemarkModal(row, data) {
      this.currentRemarkRow = row;
      this.newRemark = row && row.remarks != null ? row.remarks : "";
      this.remarkModal = true;
      var arr = [];
      for (let i = 0; i < data.length; i++) {
        arr.push(data[i]);
      }
      this.returnreasonIDs = arr;
    },
    remarkModalOk() {
      if (!this.currentRemarkRow) {
        this.$Message.error("请选择要修改备注的订单");
        return;
      }
      cmsUpdateRemark({
        items: this.returnreasonIDs,
        myremarks: this.newRemark,
      }).then((res) => {
        this.remarkModal = false;
        this.queryGoods();
      });
    },
    couriernumModalOk() {
      if (!(this.couriernum && this.couriernum.length > 0)) {
        this.$Message.error("请输入快递单号");
        return;
      }
      cmsDeliverGoods({
        items: this.returnreasonIDs,
        couriernum: this.couriernum,
      }).then((res) => {
        this.queryGoods(); // 直接调用查询函数，不用重复逻辑
      });
    },
    fahuoOrder(data) {
      this.couriernumModal = true;
      var arr = [];
      for (let i = 0; i < data.length; i++) {
        arr.push(data[i]);
      }
      this.returnreasonIDs = arr;
    },
    validatePositiveInteger(value) {
      if (value < 1 || !Number.isInteger(+value)) {
        this.$Message.error("请输入一个正整数");
        this.returnnum = "";
      }
    },
    returnOrder(data) {
      console.log("data", data);
      this.returnModal = true;
      var arr = [];
      for (let i = 0; i < data.length; i++) {
        arr.push(data[i]);
      }
      this.returnreasonIDs = arr;
    },
    returnModalOk() {
      var rnum = 0;
      if (this.isallreturn == false) {
        rnum = parseInt(this.returnnum, 0);
        if (rnum > 0) {
          if (this.returnreasonIDs[0].goodsnum < rnum) {
            alert("退回数量不能大于订单商品数量");
            return;
          }
          if (this.returnreasonIDs[0].goodsnum == rnum) {
            rnum = 0;
          }
        } else {
          this.$Message.error("请输入一个正整数");
        }
      }
      cmsReturnOrder({
        items: this.returnreasonIDs,
        source: this.selectedReturn,
        rnum: rnum,
      }).then((res) => {
        this.queryGoods(); // 直接调用查询函数，不用重复逻辑
      });
    },

    clicktongbu() {
      if (this.tongbuLoading) return;
      this.tongbuLoading = true;
      cmsTongbubendi({})
        .then(() => {
          this.$Message.success("同步本地库存成功");
          this.queryGoods();
        })
        .finally(() => {
          this.tongbuLoading = false;
        });
    },
    clickhedan() {
      console.log(JSON.stringify(this.selectedRows)); // 输出所有选中的行

      // 获取第一个对象的值作为参照
      const firstRecord = this.selectedRows[0];
      const fields = [
        "orderid",
        "user_id",
        "user_phone",
        "user_address",
        "remarks",
      ];

      let isSame = true;

      // 遍历数组中的其他对象，检查对应字段是否相同
      for (let i = 1; i < this.selectedRows.length; i++) {
        for (let field of fields) {
          console.log(this.selectedRows[i][field], firstRecord[field]);
          if (this.selectedRows[i][field] !== firstRecord[field]) {
            isSame = false;
            console.log(
              `不匹配的字段: ${field}, 第 ${i} 条记录与第一条记录不同`,
            );
            break;
          }
        }
      }

      var ids = [];
      var hebinid = this.selectedRows[0].rows[0].hebinid;
      for (var i = 0; i < this.selectedRows.length; i++) {
        for (var j = 0; j < this.selectedRows[i].rows.length; j++) {
          ids.push(this.selectedRows[i].rows[j].id);
        }
      }

      if (isSame) {
        console.log("hebinid=", hebinid);
        console.log("id=", ids);
        cmsHebinOrder({ ids: ids, hebinid: hebinid }).then((res) => {
          this.queryGoods(); // 直接调用查询函数，不用重复逻辑
        });
      } else {
        alert("有部分记录的字段不匹配。无法合单");
      }
    },
    // 查询商品
    // 公共查询函数
    fetchGoodsData(params = {}) {
      cmsSelShopOrder(params)
        .then((response) => {
          // 为每行数据添加_expanded属性设为true，使其默认展开
          const rows = response.data.rows.map((row) => {
            return { ...row, _expanded: true };
          });
          this.data9 = rows; // 获取查询结果
          this.current = response.data.pagination.page; // 获取当前页
          this.total = response.data.pagination.total; // 获取总数
        })
        .catch((error) => {
          console.error(error);
        });
    },
    clickdaochuall() {
      if (this.exportAllLoading) return;
      this.exportAllLoading = true;
      cmsAllYicaigou({
        page: 1,
        pagesize: 999999,
      })
        .then(async (response) => {
          const data = response && response.data ? response.data : {};
          const bdkarr = Array.isArray(data.bdkarr) ? data.bdkarr : [];
          const dfharr = Array.isArray(data.dfharr) ? data.dfharr : [];

          if (bdkarr.length === 0 && dfharr.length === 0) {
            this.$Message.error("暂无可导出的数据");
            return;
          }

          const exportOne = async (rows, fileName) => {
            if (!rows || rows.length === 0) return;

            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet("发货订单数据");

            worksheet.columns = [
              { header: "用户ID", key: "userId", width: 15 },
              { header: "商品名", key: "goodsName", width: 30 },
              { header: "用户信息", key: "userInfo", width: 80 },
              { header: "备注", key: "remarks", width: 15 },
              { header: "商品成本", key: "cost", width: 10 },
              { header: "商品总价", key: "totalPrice", width: 10 },
              { header: "商品数量", key: "goodsNum", width: 10 },
              { header: "", key: "", width: 15 },
              { header: "", key: "", width: 15 },
              { header: "订单号", key: "ordernum", width: 15 },
            ];

            worksheet.getRow(1).font = { bold: true };

            rows.forEach((row) => {
              if (row.rows && row.rows.length > 0) {
                row.rows.forEach((item) => {
                  const goodsNum = Number(item.goodsnum) || 0;
                  const price = Number(item.cost) || 0;
                  const totalPrice = goodsNum * price;
                  var re = row.myremarks ? row.myremarks : row.remarks;
                  const userInfo = `${this.normalizeExcelText(
                    row.user_address,
                  )} ${this.normalizeExcelText(
                    row.user_phone,
                  )} ${this.normalizeExcelText(row.user_nickname)}`.trim();

                  worksheet.addRow({
                    ordernum: this.normalizeExcelText(row.ordernum),
                    userId: this.normalizeExcelText(row.user_id),
                    userInfo: userInfo,
                    goodsName: this.normalizeExcelText(item.goodsname),
                    goodsNum: goodsNum,
                    cost: Number(item.cost) || 0,
                    totalPrice: totalPrice,
                    remarks: this.normalizeExcelText(re),
                  });
                });
              }
            });

            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });

            if (window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(blob, fileName);
            } else {
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", fileName);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
            }
          };

          const now = new Date();
          const timeSuffix = `${now.getFullYear()}${(now.getMonth() + 1)
            .toString()
            .padStart(2, "0")}${now.getDate().toString().padStart(2, "0")}_${now
            .getHours()
            .toString()
            .padStart(2, "0")}${now.getMinutes().toString().padStart(2, "0")}`;
          const bdkFileName = `本地库采购订单_${timeSuffix}.xlsx`;
          const dfhFileName = `待发货采购订单_${timeSuffix}.xlsx`;

          await exportOne(bdkarr, bdkFileName);
          await new Promise((resolve) => setTimeout(resolve, 2000));
          await exportOne(dfharr, dfhFileName);

          this.$Message.success("导出成功");
        })
        .catch((error) => {
          console.error(error);
          this.$Message.error("导出失败");
        })
        .finally(() => {
          this.exportAllLoading = false;
        });
    },
    clickdaochu3() {},
    clickdaochu() {
      // 检查是否有选中的行
      if (this.selectedRows.length === 0) {
        this.$Message.error("请先选择要导出的数据");
        return;
      }

      // 检查是否有未采购的商品
      let hasUnprocuredGoods = false;
      let unprocuredGoodsNames = [];

      // 遍历选中的行，检查是否有未采购的商品
      for (let row of this.selectedRows) {
        if (row.rows && row.rows.length > 0) {
          for (let item of row.rows) {
            // 如果 procurestatus 不等于 1，则表示未采购
            if (item.procurestatus !== 1) {
              hasUnprocuredGoods = true;
              unprocuredGoodsNames.push(item.goodsname || "未命名商品");
              // 为了避免列表过长，最多只显示3个未采购商品
              if (unprocuredGoodsNames.length >= 3) {
                break;
              }
            }
          }
          if (hasUnprocuredGoods && unprocuredGoodsNames.length >= 3) {
            break;
          }
        }
      }

      // 如果有未采购的商品，则提示并返回
      if (hasUnprocuredGoods) {
        let message = "选中数据中包含未采购的商品，无法导出！";
        if (unprocuredGoodsNames.length > 0) {
          message += "\n未采购商品包括: " + unprocuredGoodsNames.join(", ");
          if (unprocuredGoodsNames.length >= 3) {
            message += " 等...";
          }
        }
        this.$Message.error(message);
        return;
      }

      // 创建一个新的工作簿
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("发货订单数据");

      // 设置列宽
      worksheet.columns = [
        { header: "用户ID", key: "userId", width: 15 },
        { header: "用户手机号", key: "userPhone", width: 15 },
        { header: "用户姓名", key: "userNickname", width: 15 },
        { header: "用户地址", key: "userAddress", width: 80 },
        { header: "商品名", key: "goodsName", width: 30 },
        { header: "商品数量", key: "goodsNum", width: 10 },
        { header: "商品成本", key: "cost", width: 10 },
        { header: "商品总价", key: "totalPrice", width: 10 },
        { header: "商品类型", key: "goodsType", width: 15 },
        { header: "商品来源", key: "source", width: 15 },
        { header: "备注", key: "remarks", width: 15 },
      ];

      // 添加样式
      worksheet.getRow(1).font = { bold: true };

      const normalizeExportText = (value) => {
        if (value == null) return "";
        return value
          .toString()
          .replace(/\r?\n/g, " ")
          .replace(/,/g, "，")
          .replace(/"/g, "“")
          .trim();
      };

      // 遍历选中的行，提取数据
      this.selectedRows.forEach((row) => {
        if (row.rows && row.rows.length > 0) {
          row.rows.forEach((item) => {
            // 计算商品总价 = 单价 * 数量
            const goodsNum = Number(item.goodsnum) || 0;
            const price = Number(item.cost) || 0;
            const totalPrice = goodsNum * price;

            // 添加数据行
            worksheet.addRow({
              userId: row.user_id,
              userPhone: normalizeExportText(row.user_phone),
              userNickname: normalizeExportText(row.user_nickname),
              userAddress: normalizeExportText(row.user_address),
              goodsName: normalizeExportText(item.goodsname),
              goodsNum: goodsNum,
              cost: Number(item.cost) || 0,
              totalPrice: totalPrice,
              goodsType: normalizeExportText(
                this.getGoodsTypeName(item.goodstype),
              ),
              source: normalizeExportText(item.source),
              remarks: normalizeExportText(row.remarks),
            });
          });
        }
      });

      // 生成Excel文件
      workbook.xlsx
        .writeBuffer()
        .then((buffer) => {
          // 创建Blob对象
          const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          // 生成文件名
          const now = new Date();
          const fileName = `已采购订单_${now.getFullYear()}${(
            now.getMonth() + 1
          )
            .toString()
            .padStart(2, "0")}${now.getDate().toString().padStart(2, "0")}_${now
            .getHours()
            .toString()
            .padStart(2, "0")}${now
            .getMinutes()
            .toString()
            .padStart(2, "0")}.xlsx`;

          // 下载文件
          if (window.navigator.msSaveOrOpenBlob) {
            // 对IE的支持
            window.navigator.msSaveOrOpenBlob(blob, fileName);
          } else {
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url); // 释放创建的URL
          }

          this.$Message.success("导出成功");
        })
        .catch((err) => {
          console.error("导出失败:", err);
          this.$Message.error("导出失败");
        });
    },
    // 查询商品
    queryGoods() {
      const params = {
        user_id: this.searchId || undefined,
        goodsname: this.searchName || undefined,
        goodstype: this.searchType || undefined,
        page: this.current,
      };
      this.fetchGoodsData(params);
    },

    // 分页查询
    changePage(e) {
      this.current = e;
      this.queryGoods(); // 直接调用查询函数，不用重复逻辑
    },

    // 获取商品类型名称
    getGoodsTypeName(typeCode) {
      if (!typeCode) return "";

      // 查找对应的商品类型名称
      const typeItem = this.goodstypeOptions.find(
        (item) => item.value === typeCode,
      );
      return typeItem ? typeItem.label : typeCode.toString();
    },
  },
};
</script>
